import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogContenText from '@mui/material/DialogContentText'
import { CopyToClipboard } from 'react-copy-to-clipboard'

import styles from './app.module.css'
import App from './App'
import { showSuccessMsg } from '../util/messagesUtil'

const isChrome = window.navigator.userAgent.indexOf('Chrome') !== -1
const imgChrome = '/images/logo-chrome.svg'
const imgFirefox = '/images/logo-firefox.svg'
const urlChrome = 'chrome://chrome'
const urlFirefox = 'about:preferences'

export class UpdateBrowser extends Component {
  constructor(props) {
    super(props)
    this.state = {
      url: isChrome ? urlChrome : urlFirefox
    }
  }

  handleOnCopy() {
    showSuccessMsg('Copiado para área de transferência.')
  }

  render() {
    const { url } = this.state
    return (
      <App noAppToolbar>
        <Dialog open PaperProps={{ className: styles.dialogPaperClassName, elevation: 2 }}>
          <DialogTitle disableTypography>
            <img
              src={isChrome ? imgChrome : imgFirefox}
              alt='Logo'
              className={styles.logoBrowser}
            />
          </DialogTitle>
          <DialogContent>
            <DialogContenText component='div'>
              <Typography variant='h6' style={{ maxWidth: 500 }}>
                O seu navegador está desatualizado
              </Typography>
            </DialogContenText>
            <DialogContenText component='div'>
              <Typography variant='subtitle1' className={styles.dialogItem}>
                Infelizmente seu navegador se encontra desatualizado. Isso pode causar erros ou
                dificultar o funcionamento de vários sites e sistemas para você. Além do mais, ter o
                navegador desatualizado também deixa sua navegação menos segura. É bem fácil
                atualizá-lo, basta seguir as instruções:
              </Typography>
            </DialogContenText>
            <DialogContenText component='div'>
              <Typography variant='subtitle2' style={{ fontWeight: 'bold' }}>
                1. Copie e cole o seguinte código em seu navegador para atualizá-lo
              </Typography>
            </DialogContenText>
            <DialogContenText component='div'>
              <TextField defaultValue={url} InputProps={{ readOnly: true }} />
              <CopyToClipboard text={url} onCopy={this.handleOnCopy.bind(this)}>
                <Button>Copiar Código</Button>
              </CopyToClipboard>
            </DialogContenText>
            <DialogContenText component='div'>
              <Typography variant='subtitle2' style={{ fontWeight: 'bold' }}>
                {isChrome
                  ? '2. Aguarde o navegador baixar e instalar as atualizações'
                  : '2. Em "Atualização do Firefox" selecionar a opção "Reiniciar parar atualizar o Firefox"'}
              </Typography>
            </DialogContenText>
            <DialogContenText component='div'>
              <Typography variant='subtitle2' style={{ fontWeight: 'bold' }}>
                3. Pronto! Seu navegador está atualizado
              </Typography>
            </DialogContenText>
          </DialogContent>
        </Dialog>
      </App>
    )
  }
}

export default withRouter(UpdateBrowser)
